import React from "react"
export function WindowSeat(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 1.5a6.5 6.5 0 016.496 6.267L16.5 8v4a6.5 6.5 0 01-12.996.233L3.5 12V8A6.5 6.5 0 0110 1.5zM6.91 11.955c-.92 0-1.748.396-2.322 1.027a5.5 5.5 0 009.83 2.294 3.13 3.13 0 00-3.811-.813.5.5 0 01-.701-.3 3.138 3.138 0 00-2.997-2.208zm8.59-2.942h-11v2.716a4.115 4.115 0 012.172-.768l.237-.006c1.542 0 2.92.851 3.63 2.15l.097.19.029.063.156-.05c.227-.068.46-.116.698-.144l.24-.02.241-.008c1.16 0 2.207.477 2.958 1.246.304-.63.491-1.328.533-2.064L15.5 12V9.013zM10 2.5a5.5 5.5 0 00-5.496 5.279l-.004.234h11V8a5.5 5.5 0 00-5.279-5.496L10 2.5zM11.5 6v1h-3V6h3z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__window-seat"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
